import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import companyLogo from '../assets/company-logo.svg';
import { registerUser } from '../api/authService';

const API_URL = process.env.REACT_APP_API_URL || "";

function Register() {
  const [form, setForm] = useState({ email: '', password: '', confirmPassword: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    if (form.password !== form.confirmPassword) {
      setError('Passwords do not match.');
      return false;
    }

    const email = form.email.trim().toLowerCase();
    if (email) {
      if (!email.endsWith('@redwood-partners.de')) {
        setError('Only @redwood-partners.de email addresses are allowed to register.');
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    setMessage('');
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);

    try {
      const data = await registerUser({ email: form.email, password: form.password });
      setMessage(data.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-auth">
      <div className="box-auth">
        <div className="logo-wrapper">
          <img src={companyLogo} alt="Redwood Midcap" className="logo" />
        </div>

        {message && (
          <div className="auth-success-message">
            <p>{message}</p>
            <button className="button-auth" onClick={() => navigate('/login')}>
              Continue to Login
            </button>
          </div>
        )}

        <div className="auth-error-container">
          {error && (
            <div className="auth-error-message">{error}</div>
          )}
        </div>

        {!message && (
          <form onSubmit={handleSubmit}>
            <div className="form-header-auth">
              <h2>Create account</h2>
              <p>Enter your email below to create your account</p>
            </div>

            <div className="form-group-auth">
              <label className="label-auth" for="email">Email</label>
              <input 
                name="email" 
                className="input-field-auth" 
                placeholder="your.name@redwood-partners.de" 
                value={form.email} 
                onChange={handleChange} 
              />
              <small className="email-hint">
                Only @redwood-partners.de email addresses are accepted!
              </small>
            </div>

            <div className="form-group-auth">
              <label className="label-auth" for="email">Password</label>
              <input 
                type="password"  
                className="input-field-auth"
                name="password" 
                placeholder="Password" 
                value={form.password} 
                onChange={handleChange} 
              />
            </div>
            <div className="form-group-auth">
              <label className="label-auth" for="email">Confirm Password</label>
              <input 
                type="password" 
                className="input-field-auth" 
                name="confirmPassword" 
                placeholder="Confirm Password" 
                value={form.confirmPassword} 
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="button-auth" disabled={loading}>
              {loading ? (
                <>
                  Registering<span className="dots" />
                </>
              ) : 'Register'}            
            </button>
          </form>
        )}
        {!message && (
          <p className="signup-text">
            Already have an account? <Link to="/login">Login here</Link>
          </p>
        )}
      </div>
    </div>
  );
}

export default Register;